<template>
  <div id="about">
    <div class="banner" id="a1">
      <BannerDetail src="https://website.obs.icheer.cn/icheer-web/images/about-icheer/banner.jpg"/>
    </div>
    <div class="main">
      <div class="normal">
        <div class="icheer">
          <div class="title">公司简介</div>
          <div class="content">
            <div class="left " >
              <el-image fit="contain" class="icheer-content-img" src="https://website.obs.icheer.cn/icheer-web/images/about-icheer/company-logo-2025.png"/>
            </div>
            <div class="right" id="a2">
              <div class="div1">泉州艾奇科技有限公司（Quanzhou Icheer Technology Co., Ltd.）是易客创新开发机构旗下的核心成员企业，致力于为电商公司提供智能电子产品方向的全方位配套解决方案。</div>
              <div class="div2">服务涵盖：特色选品、市场调研、外观设计、产品开发、ODS量产配套、知识产权、品牌营销、流量共享、联合采购等。 </div>
            </div>
          </div>
        </div>
<!--        <div class="eiker" id="a2">-->
<!--          <div class="title">易客创新</div>-->
<!--          <div class="content">-->
<!--            易客创新由一众志同道合、追梦未来的业内资深专家联合创办，是清华领军的领先务实型综合设计开发机构，专注于智能硬件领域的产品极致优化开发，拥有创新开拓型企业方阵：以色工业设计、艾奇方案设计、昆泰芯片设计，致力于为业内合作伙伴提供质优价廉的全方位高端极致服务，分享共赢，同创未来。-->
<!--            <img src="https://website.obs.icheer.cn/icheer-web/images/about-icheer/company-logo-2025.png" alt="易客创新"/>-->
<!--          </div>-->
<!--        </div>-->
        <div class="vision"  >
          <div class="title">使命愿景</div>
          <div class="content" id="a7" >让美好世界更美好</div>
        </div>
        <div class="methodology" id="a5">
          <div class="title">企业方法论</div>
          <div class="content">
            <div class="div1">汇泉润州</div>
            <div class="div2">
              我们向行业学习，不忽略行业的沉淀，不闭门造车。<br>
              我们复用现有的优质供应链资源。<br>
              我们通过通用技术模块化与有效能力组合提高行业效率，降低成本。<br>
              我们在同事间倡导同学机制，互相学习，互帮互助，形成集体智慧。<br>
              我们对采用他人的建议及方法取得的成绩感到自豪。<br>
              我们以润物细无声的方式不断精进。
            </div>
          </div>
        </div>
        <div class="values" id="a4">
          <div class="title">企业价值观</div>
          <div class="content">
            <div class="div1">成人达己</div>
            <div class="div2">
              我们不断完善和发展壮大自己，是为了更好地服务客户和社会，更好地帮助和促成别人实现价值，让我们所处的行业和社会更加美好。<br>
              我们发展与客户、供应商之间紧密互惠的关系，分享共赢，同创未来。
              我们坚信团队力量，我们倡导可复用可共享的能力。<br>
              我们的各个业务组织和部门之间相互信任，紧密合作。
            </div>
          </div>
        </div>
        <div class="members">
          <div class="title">艾奇团队</div>
          <img src="https://website.obs.icheer.cn/icheer-web/images/about-icheer/people.png?x-image-process=image/resize,w_1920,limit_0" alt=""/>
          <p>艾奇虽然总部在泉州，但是汇聚了全国各地的志同道合、追梦未来的专家人才。</p>
          <div class="icheer-list" >
            <div class="item" v-for="item in icheerList" :key="item.desc">
              <div class="text">
                <div class="initial">{{ item.upperCase }}</div>
                <div class="description">{{ item.desc }}</div>
                <div class="character">{{ item.character }}</div>
              </div>
            </div>
          </div>
          <div class="icheer-form" id="a3">
            <div class="item" v-for="item in icheerFrom" :key="item.english">
                <span class="span1">{{ item.character }}</span>
                <span class="span2">{{ item.english }}</span>
                <span class="span3">{{ item.desc }}</span>
            </div>
          </div>
        </div>
        <div class="patent" id="a6">
          <div class="title">专利资质</div>
          <div class="awardTotal">
              <div class="slider_smv_con_97_6 con_97_6  slide_Style6 ">
                <div class="w-slider" id="slider_smv_con_97_6">
                  <div class="w-slider-wrap" data-u="slides" style="height:500px;">
                    <div class="w-slider-item" v-for="(imgItem,index) in verificationImg" :key="index">
                      <el-image :hide-on-click-modal="true" data-u="image" class="CutFill" fit="cover" :src="imgItem" :initial-index="index" :preview-src-list="verificationImg" :preview-teleported="preview"/>
                    </div>
                  </div>
                </div>
              </div>
              <BrandLogoBarnerFooter  />
          </div>
        </div>

<!--        <div class="patent" >-->
<!--          <div class="title">商标声明</div>-->
<!--          <div class="awardTotal">-->
<!--            <div class="slider_smv_con_97_6 con_97_6  slide_Style6 ">-->
<!--              <div class="w-slider w-slider-height " id="slider_smv_con_97_6_1">-->
<!--                <div class="w-slider-wrap" data-u="slides" style="height:500px;">-->
<!--                  <div class="w-slider-item" v-for="(imgItem,index) in brandLogoList" :key="imgItem">-->
<!--                    <el-image :hide-on-click-modal="true" data-u="image" class="core-brand-img" fit="cover" :src="imgItem" :initial-index="index" :preview-src-list="brandLogoList" :preview-teleported="preview"/>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="core-brand-bar" >-->
<!--            核心商标：-->
<!--            <el-image  class="core-brand-img" src="https://website.obs.icheer.cn/icheer-web/images/logo/coreBrandLogo-tm.png" />-->
<!--          </div>-->
<!--        </div>-->

      </div>
    </div>
  </div>
</template>
<script setup>
import BannerDetail from './BannerDetail.vue'
// import ImageTextLine from '@/components/ImageTextLine.vue'
import { watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import $ from '../../public/static/jquery.min'
import '../../public/static/jssor.slider-22.2.16-all.min'
import '../../public/static/slide.css'
import BrandLogoBarnerFooter from '@/components/BrandLogoBarnerFooter.vue'

// 提供图片链接
const verificationImg = [
  'https://website.obs.icheer.cn/icheer-web/images1/about/patent7.jpg',
  'https://website.obs.icheer.cn/icheer-web/images1/about/patent9.jpg',
  'https://website.obs.icheer.cn/icheer-web/images1/about/patent10.jpg',
  'https://website.obs.icheer.cn/icheer-web/images1/about/patent2.jpg',
  'https://website.obs.icheer.cn/icheer-web/images1/about/patent11.jpg'
]
// 商标列表
const brandLogoList = [
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC001.png',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC002.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC003.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC004.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC005.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC005.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC006.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC007.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC008.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC009.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC010.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC011.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC012.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC013.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC014.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC015.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC016.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC017.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC018.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC019.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC020.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-AC021.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-WX001.png',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-WX002-3.png',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS005.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS006.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS007.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS008.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS009.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS010.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS011.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS012.jpg',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS014.png',
  'https://website.obs.icheer.cn/icheer-web/coreBrand/IPC-TM-YS016.jpg'

]
const $router = useRouter()
const preview = true
const icheerList = [
  {
    upperCase: 'I',
    desc: 'Integrity',
    character: '正直'
  },
  {
    upperCase: 'C',
    desc: 'Cooperative',
    character: '协作'
  },
  {
    upperCase: 'H',
    desc: 'Happy',
    character: '快乐'
  },
  {
    upperCase: 'E',
    desc: 'Energize',
    character: '积极'
  },
  {
    upperCase: 'E',
    desc: 'Enable',
    character: '赋能'
  },
  {
    upperCase: 'R',
    desc: 'Reliable',
    character: '可靠'
  }
]
const icheerFrom = [
  {
    character: '正直',
    english: 'Integrity',
    desc: '坚持真理，诚实正直'
  },
  {
    character: '协作',
    english: 'Cooperative',
    desc: '有合作精神的，齐心协力，同舟共济'
  },
  {
    character: '快乐',
    english: 'Happy',
    desc: '快乐生活与工作，和业界朋友共同轻松愉快地推动更高效更美好的新奇特碎广美'
  },
  {
    character: '积极',
    english: 'Energize',
    desc: '有积极向上的活力，满怀热情，不抱怨，热爱工作，热爱生活；能鼓舞团队完成有挑战性的任务，并享受战胜困难的喜悦'
  },
  {
    character: '赋能',
    english: 'Enable',
    desc: '赋能行业，乐于分享，为业界朋友提供有效的产品优化与升级服务'
  },
  {
    character: '可靠',
    english: 'Reliable',
    desc: '我们专业的技术与服务，让我们成为可靠的盟友，可信赖的合作伙伴'
  }
]

onMounted(() => {
  watch(() => $router.currentRoute.value.query, (newValue, oldValue) => {
    const arch = $router.currentRoute.value.query.arch
    if (arch == null) return
    const target = document.querySelector(`#${arch}`)
    target.scrollIntoView({
      behavior: 'smooth'
    })
  }, { immediate: true })

  const jssorOptions = {
    $AutoPlay: true,
    $Idle: 0,
    $SlideEasing: window.$Jease$.$Linear,
    $AutoPlaySteps: 1,
    $SlideDuration: parseInt('3000'),
    $SlideWidth: 250,
    $SlideHeight: 500,
    $SlideSpacing: 20,
    $Cols: 4,
    $PauseOnHover: 7
  }
  const slide = new window.$JssorSlider$('slider_smv_con_97_6', jssorOptions)


})

</script>

<style scoped>
#about {
  width: 100%;
  height: auto;
  min-width: 375px
}

#about>.banner,#about>.main {
  width: 100%;
  height: auto;
  min-width: 375px;
  margin: 0 auto
}

#about>.main{
  padding-top: 2.74vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}

#about>.main>.normal {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.icheer {
  width: 52vw;
  height: auto;
  margin-bottom: 4vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.icheer>.title {
  letter-spacing: 0.018vw;
  font-size: 1.75vw;
  font-weight: 700;
  margin-bottom: 1.25vw;
  font-family: HarmonyOS_Sans_SC_Medium
}

#about>.main>.normal>.icheer>.content{
  width: 100%;
  height: 19.55vw;
  display: flex;
  flex-direction: row;
  background-color: #f5f5f5;
  border-radius: .5vw
}


#about>.main>.normal>.icheer>.content>.left {
  width: 54.2vw;
  height: auto
}

#about>.main>.normal>.icheer>.content>.left >.icheer-content-img {

  height: 100%;
  border-radius: 0.5vw;
  object-fit: contain;
}

#about>.main>.normal>.icheer>.content>.right{
  width: 46vw;
  height: 100%;
  padding-top: 3.45vw;
  padding-left: 2vw;
  padding-right: 2vw;
}

#about>.main>.normal>.icheer>.content>.right>.div1{
  font-size: 0.82vw;
  line-height: 1.83vw;
  letter-spacing: 0.025vw;
  margin-bottom: 1.7vw;
}

#about>.main>.normal>.icheer>.content>.right>.div2 {
  font-size: 0.82vw;
  line-height: 1.83vw;
  letter-spacing: 0.025vw
}

#about>.main>.normal>.eiker{
  width: 52vw;
  height: auto;
  margin-bottom: 3.8vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.eiker>.title{
  letter-spacing: 0.018vw;
  font-size: 1.75vw;
  font-weight: 700;
  margin-bottom: 1.42vw;
  font-family: HarmonyOS_Sans_SC_Medium
}

#about>.main>.normal>.eiker>.content {
  width: 100%;
  height: auto;
  font-size: 0.94vw;
  line-height: 1.78vw;
  display: flex;
  flex-direction: column;
  border-radius: 5vw
}

#about>.main>.normal>.eiker>.content img {
  width: 100%;
  height: auto;
  margin-top: 0.93vw;
  border-radius: 0.5vw
}

#about>.main>.normal>.vision{
  width: 52vw;
  height: auto;
  margin-bottom: 2.75vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.vision>.title {
  letter-spacing: 0.018vw;
  font-size: 1.75vw;
  font-weight: 700;
  margin-bottom: 1.25vw;
  font-family: HarmonyOS_Sans_SC_Medium
}

#about>.main>.normal>.vision>.content {
  width: 100%;
  height: 20.85vw;
  font-size: 1.46vw;
  line-height: 1.78vw;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  color: #fff;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/about/vision.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%
}

#about>.main>.normal>.methodology {
  width: 52vw;
  height: auto;
  margin-bottom: 2.75vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.methodology>.title{
  letter-spacing: 0.018vw;
  font-size: 1.75vw;
  font-weight: 700;
  margin-bottom: 1.2vw;
  font-family: HarmonyOS_Sans_SC_Medium
}

#about>.main>.normal>.methodology>.content {
  width: 100%;
  height: 20.8vw;
  font-size: 0.94vw;
  line-height: 1.78vw;
  display: flex;
  flex-direction: column;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/about/methodology.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%
}

#about>.main>.normal>.methodology>.content>.div1{
  font-size: 1.55vw;
  width: 60%;
  height: 3vw;
  padding-top: 3.15vw;
  padding-left: 3.15vw
}

#about>.main>.normal>.methodology>.content>.div2{
  font-size: 0.83vw;
  width: 60%;
  height: auto;
  line-height: 1.55vw;
  padding-left: 3.15vw
}

#about>.main>.normal>.values{
  width: 52vw;
  height: auto;
  margin-bottom: 2.8vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.values>.title{
  letter-spacing: 0.018vw;
  font-size: 1.75vw;
  font-weight: 700;
  margin-bottom: 1.25vw;
  font-family: HarmonyOS_Sans_SC_Medium
}

#about>.main>.normal>.values>.content{
  width: 100%;
  height: 20.8vw;
  font-size: 0.94vw;
  line-height: 1.78vw;
  display: flex;
  flex-direction: column;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/about/values.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%
}

#about>.main>.normal>.values>.content>.div1{
  font-size: 1.55vw;
  width: 50%;
  height: 3vw;
  padding-top: 3.15vw;
  padding-left: 3.15vw
}

#about>.main>.normal>.values>.content>.div2{
  font-size: 0.83vw;
  width: 50%;
  height: auto;
  line-height: 1.55vw;
  padding-left: 3.15vw
}

#about>.main>.normal>.members{
  width: 52vw;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.members>.title{
  letter-spacing: 0.018vw;
  font-size: 1.75vw;
  font-weight: 700;
  margin-bottom: 1.37vw;
  font-family: HarmonyOS_Sans_SC_Medium
}

#about>.main>.normal>.members img{
  width: 100%;
  height: 20.8vw;
  border-radius: 0.5vw;
  object-fit: cover;
  margin-bottom: 0.47vw
}

#about>.main>.normal>.members p {
  width: 100%;
  font-size: 0.92vw;
  display: flex;
  text-align: start;
  align-items: flex-start;
  letter-spacing: 0.01vw;
  margin-bottom: 1.3vw
}

#about>.main>.normal>.members .icheer-list{
  width: 100%;
  height: auto;
  margin-bottom: 1.3vw;
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center
}

#about>.main>.normal>.members .icheer-list .item{
  display: flex;
  width: 16.5%;
  height: auto;
  margin: 0 0.2vw;
  border-radius: 0.5px;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-weight: 700
}

#about>.main>.normal>.members .icheer-list .item .text {
  width: 7.8vw;
  height: 7.4vw;
  position: relative;
  background-color: #f5f6f8;
  border-radius: 0.6vw;
  display: flex;
  text-align: center
}

#about>.main>.normal>.members .icheer-list .item .text>.initial{
  position: absolute;
  color: #eaebed;
  top: -0.3vw;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 1;
  font-size: 7vw
}

#about>.main>.normal>.members .icheer-list .item .text>.description{
  width: 100%;
  height: 100%;
  font-size: 1.1vw;
  margin: 2.7vw auto;
  z-index: 2;
  display: flex;
  flex-direction: column;
  text-align: center
}

#about>.main>.normal>.members .icheer-list .item .text:hover>.initial{
  color: #2f80e9
}

#about>.main>.normal>.members .icheer-list .item .text:hover>.description{
  display: none
}

#about>.main>.normal>.members .icheer-list .item .text>.character{
  display: none;
  width: 100%;
  height: 100%;
  background-color: #338afb;
  z-index: 3;
  border-radius: 0.5vw;
  color: #fff;
  font-size: 1.1vw;
  margin: auto;
  justify-content: center;
  align-items: center
}

#about>.main>.normal>.members .icheer-list .item .text:hover>.character{
  display: flex
}

#about>.main>.normal>.members .icheer-form{
  width: 100%;
  height: auto;
  margin-bottom: 1.8vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#about>.main>.normal>.members .icheer-form .item{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row
}

#about>.main>.normal>.members .icheer-form .item .span1{
  width: 7%;
  height: 1.2vw;
  font-weight: 700;
  font-size: 0.8vw
}

#about>.main>.normal>.members .icheer-form .item .span2{
  width: 10%;
  height: 1.2vw;
  font-size: 0.8vw
}

#about>.main>.normal>.members .icheer-form .item .span3{
  width: 83%;
  height: 1.2vw;
  font-size: 0.8vw
}

#about>.main>.normal>.patent{
  width: 52vw;
  height: auto;
  margin-bottom: 3.5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center
}

#about>.main>.normal>.patent>.title{
  letter-spacing: 0.018vw;
  font-size: 1.75vw;
  font-weight: 700;
  margin-bottom: 1.42vw;
  font-family: HarmonyOS_Sans_SC_Medium
}

#about>.main>.normal>.patent>.awardTotal{
  width: 100%;
  max-height: 80%
}

#about>.main>.normal>.patent>.awardTotal .slider_smv_con_97_6{
  vertical-align: middle;
  overflow: hidden;
  height: auto
}

#about>.main>.normal>.patent{
  .w-slider {
    height: 250px !important;
  }
  .w-slider-height{
    height: 350px !important;
  }
}
#about>.main>.normal>.patent .w-slider{
  .core-brand-img{
    padding: 0px;
    width: 100%;
  }
}
#about>.main>.normal>.patent .core-brand-bar{
  font-size: 0.8vw;
  width: 100%;
  height: auto;
  margin-top: 1vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center
}
#about>.main>.normal>.patent .core-brand-bar .core-brand-img{
  width: 92%;
}
</style>
